<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1"
       style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
       viewBox="0 0 7243 7243"
       xmlns:xlink="http://www.w3.org/1999/xlink">
 <g id="Vrstva_x0020_1">
  <rect class="fil0" width="7243" height="7243" />
   <circle class="fil1" cx="3622" cy="3622" r="3347" />
   <g id="_596370208">
   <path class="fil2"
         d="M1355 3511c0,449 40,754 239,1143 417,818 728,665 728,460 0,-143 -121,-207 -194,-303 -540,-709 -558,-1633 -23,-2347 59,-79 217,-216 217,-307 0,-203 -200,-265 -354,-105 -332,346 -613,948 -613,1459z" />
     <path class="fil2"
           d="M4920 2129c0,225 609,506 609,1520 0,892 -609,1294 -609,1438 0,202 201,265 354,105 49,-50 87,-109 136,-169 76,-94 175,-247 230,-350 708,-1357 -271,-2710 -526,-2710 -112,0 -194,61 -194,166z" />
     <path class="fil2"
           d="M3013 3594c0,387 288,636 525,636 217,0 373,-13 533,-186 306,-330 181,-1030 -477,-1030 -312,0 -581,268 -581,580z" />
     <path class="fil2"
           d="M2101 3539c0,293 28,560 166,801 388,674 580,352 580,249 0,-228 -386,-283 -386,-1023 0,-189 72,-373 137,-498 126,-241 249,-270 249,-386 0,-177 -194,-321 -399,-40 -193,263 -347,519 -347,897z" />
     <path class="fil2"
           d="M4395 2654c0,238 387,280 387,1023 0,526 -387,751 -387,885 0,176 194,320 400,40 273,-374 347,-555 347,-1063 0,-437 -348,-1050 -553,-1050 -112,0 -194,60 -194,165z" />
  </g>
 </g>
</svg>
</template>

<script>
export default {
  name: "AlarmDetector",
};
</script>

<style scoped>
.fil0 {
  fill: none
}

.fil2 {
  fill: #FEFEFE
}

.fil1 {
  fill: #56D6D1
}
</style>
